export default {
	'shared.all': 'Все',
	'shared.minutes': 'минут',
	'shared.submit': 'Отправить',
	'shared.closeDrawer': 'Закрыть панель',
};
